import { Pipe, PipeTransform } from '@angular/core';
import { Frequency } from './planned-maintenance-library-item';
import { I18NextPipe } from 'angular-i18next';

@Pipe({
  name: 'plannedMaintenanceFrequency',
})
export class PlannedMaintenanceFrequencyPipe implements PipeTransform {
  constructor(private i18NextPipe: I18NextPipe) {
  }
  transform(value: Frequency, args?: any): string {
    switch (value) {
      case Frequency.Calendar: {
        return this.i18NextPipe.transform('PlannedMaintenanceFrequencyPipe.Calendar');
      }
      case Frequency.HoursRun: {
        return this.i18NextPipe.transform('PlannedMaintenanceFrequencyPipe.HoursRun');
      }
      default: {
        return Frequency[value];
      }
    }
  }
}
